
export const manifestoTranslations = {
  manifestoTitle: {
    fr: "Le manifeste",
    en: "The manifesto"
  },
  manifestoQuote: {
    fr: "\"Ce club n'est pas une destination. C'est un passage.\"",
    en: "\"This club is not a destination. It's a passage.\""
  },
  manifestoParagraph1: {
    fr: "Singularité.club est né d'une conviction simple : le succès est le fruit de rencontres réelles, d'échanges sincères et d'actions concrètes. Pas de réseautage superficiel, pas de cartes de visite qui finissent au fond d'un tiroir.",
    en: "Singularité.club was born from a simple conviction: success is the result of real meetings, sincere exchanges and concrete actions. No superficial networking, no business cards that end up at the bottom of a drawer."
  },
  manifestoParagraph2: {
    fr: "Dans un monde où tout s'accélère, nous croyons à la valeur du temps partagé, des compétences mises en commun et des projets co-construits. Singularité.club est ce lieu où les doers du monde entier se retrouvent pour transformer leurs idées en réalités.",
    en: "In a world where everything is accelerating, we believe in the value of shared time, pooled skills and co-constructed projects. Singularité.club is the place where doers from around the world come together to transform their ideas into realities."
  },
  manifestoParagraph3: {
    fr: "Notre mission est de cultiver ce terreau fertile où naissent les collaborations qui changent la donne. Si vous êtes de ceux qui font plutôt que ceux qui parlent, Singularité.club est fait pour vous.",
    en: "Our mission is to cultivate this fertile ground where game-changing collaborations are born. If you are one of those who do rather than those who talk, Singularité.club is for you."
  }
};
